import { render, staticRenderFns } from "./ConfigBooleanElement.vue?vue&type=template&id=5bfe3ab6&scoped=true&"
import script from "./ConfigBooleanElement.vue?vue&type=script&lang=js&"
export * from "./ConfigBooleanElement.vue?vue&type=script&lang=js&"
import style0 from "./ConfigBooleanElement.vue?vue&type=style&index=0&id=5bfe3ab6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfe3ab6",
  null
  
)

export default component.exports